import { Select } from "antd";
import { SelectProps } from "./type";

function AntSelect<T>(props: SelectProps<T>) {
  return <Select {...props} />;
}

export const AntOptions = Select.Option;
export { AntOptions as Option, AntSelect as Select };
